import { render } from "./Flatpickr.vue?vue&type=template&id=31cf5896&lang=pug"
import script from "./Flatpickr.vue?vue&type=script&setup=true&lang=js"
export * from "./Flatpickr.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__